export default __webpack_public_path__ + "knowledgeBaseIcon2.png";